import React, { Suspense, lazy } from 'react';
import { FontLoader } from './components/FontLoader';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
// Lazy load below-the-fold sections
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const Dolores = lazy(() => import('./components/Dolores').then(m => ({
  default: m.Dolores
})));
const Mecanismo = lazy(() => import('./components/Mecanismo').then(m => ({
  default: m.Mecanismo
})));
const Solucion = lazy(() => import('./components/Solucion').then(m => ({
  default: m.Solucion
})));
const VsSection = lazy(() => import('./components/VsSection').then(m => ({
  default: m.VsSection
})));
const Bonos = lazy(() => import('./components/Bonos').then(m => ({
  default: m.Bonos
})));
const Oferta = lazy(() => import('./components/Oferta').then(m => ({
  default: m.Oferta
})));
const Upsell = lazy(() => import('./components/Upsell').then(m => ({
  default: m.Upsell
})));
const Transformacion = lazy(() => import('./components/Transformacion').then(m => ({
  default: m.Transformacion
})));
const Garantia = lazy(() => import('./components/Garantia').then(m => ({
  default: m.Garantia
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Costo = lazy(() => import('./components/Costo').then(m => ({
  default: m.Costo
})));
const Urgencia = lazy(() => import('./components/Urgencia').then(m => ({
  default: m.Urgencia
})));
const Cierre = lazy(() => import('./components/Cierre').then(m => ({
  default: m.Cierre
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
function SectionFallback() {
  return <div className="section-padding bg-cream" aria-hidden="true" data-id="element-0">
      <div className="container-custom" data-id="element-1">
        <div className="h-[200px]" data-id="element-2" />
      </div>
    </div>;
}
export function App() {
  return <div className="min-h-screen flex flex-col font-sans text-ink bg-cream" data-id="element-3">
      <FontLoader data-id="element-4" />
      <Nav data-id="element-5" />
      <main data-id="element-6">
        <Hero data-id="element-7" />
        <Suspense fallback={<SectionFallback data-id="element-9" />} data-id="element-8">
          <SocialProof data-id="element-10" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-12" />} data-id="element-11">
          <Dolores data-id="element-13" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-15" />} data-id="element-14">
          <Mecanismo data-id="element-16" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-18" />} data-id="element-17">
          <Solucion data-id="element-19" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-21" />} data-id="element-20">
          <VsSection data-id="element-22" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-24" />} data-id="element-23">
          <Bonos data-id="element-25" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-27" />} data-id="element-26">
          <Oferta data-id="element-28" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-30" />} data-id="element-29">
          <Upsell data-id="element-31" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-33" />} data-id="element-32">
          <Transformacion data-id="element-34" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-36" />} data-id="element-35">
          <Garantia data-id="element-37" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-39" />} data-id="element-38">
          <FAQ data-id="element-40" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-42" />} data-id="element-41">
          <Costo data-id="element-43" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-45" />} data-id="element-44">
          <Urgencia data-id="element-46" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-48" />} data-id="element-47">
          <Cierre data-id="element-49" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-50">
        <Footer data-id="element-51" />
      </Suspense>
      <SocialProofPopup data-id="element-52" />
      <FloatingCTA data-id="element-53" />
    </div>;
}